import { Component, OnInit, enableProdMode } from '@angular/core';
import { User } from './_models/user';
import { Router } from '@angular/router';
import { AuthenticationService } from './_services/authentication.service';
//import { UserService } from './_services/user.service';
import { getTypeNameForDebugging } from '@angular/common/src/directives/ng_for_of';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';
  currentUser: User;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    //private userService: UserService
  ) {

  }

  ngOnInit(): void {
    //this.authenticationService.currentUser.subscribe(x => this.currentUser = x);
    this.authenticationService.currentUser.subscribe(
      x => { this.currentUser = x; },
      err => { console.log(err); },
      () => {
        console.log("currentUser: ");
        console.log(this.currentUser);
        console.log(this.authenticationService.getRoles());
      }
    );
  }

  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }

  activeRoleChange(event) {
    console.log(event.target.innerText);
    this.authenticationService.setActiveRole(event.target.innerText);
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts